import axios from "axios";
import { firebaseFunctionsUrl } from "../Helpers/FirebaseEnvironments";

export const formatDetailedBBRdata = (data: any) => {
  const generateHtml = (obj: any): string => {
    if (Array.isArray(obj)) {
      return `<ul>${obj.map((item) => `<li>${generateHtml(item)}</li>`).join("")}</ul>`;
    } else if (typeof obj === "object" && obj !== null) {
      return `<ul>${Object.entries(obj)
        .map(([key, value]) => {
          if (typeof value === "object" && value !== null) {
            return `<li><strong>${key}:</strong>${generateHtml(value)}</li>`;
          } else {
            return `<li><strong>${key}:</strong> ${value ?? "N/A"}</li>`;
          }
        })
        .join("")}</ul>`;
    } else {
      return `${obj}`;
    }
  };

  return generateHtml(data);
};

export const getBbrById = async (criteria: string) => {
  try {
    if (criteria.trim()) {
      const registerUrl =
        "https://certservices.datafordeler.dk//BBR/BBRPublic/1/rest/enhed?adresseidentificerer=" +
        criteria;
      const res = await axios.get(firebaseFunctionsUrl("register"), {
        params: { apiUrl: registerUrl },
      });
      console.log("Response from BBR API:", res.data);
      const result = JSON.stringify(res.data);
      if (result) {
        console.info("Response from BBR API:", result); //
        const formattedResult = formatDetailedBBRdata(JSON.parse(result));
        return formattedResult;
      } else {
        return "Web address not found.";
      }
    } else {
      return "Please enter a topic before generating output.";
    }
  } catch (error) {
    return "Get data failed: " + (error as Error).message;
  } finally {
  }
};
